<template>
  <div>
    <div
      v-if="getComentariosPage.data.length === 0"
      class="mb-6"
    >
      Nenhum comentário adicionado.
    </div>
    <div
      v-for="(comentario, index) in getComentariosPage.data"
      :key="index"
      class="py-3 d-flex"
    >
      <div >
        <b>{{ comentario.authorName }}</b>
        <span class="px-3"> {{ comentario.dataEvento | formatDataEvento }}</span>
        <v-btn
          v-if="sessionAuthor === comentario.authorName"
          @click="() => handleDeleteComent(comentario.id)"
          text
          small
          color="#f00"
          class="font-weight-bold"
        >
          Apagar
        </v-btn>
        <br/>
        <p class="mb-0 mt-1">{{ comentario.descricao }}</p>
      </div>

    </div>
    <div class="comentario-form-container">
      <v-form
        ref="commentForm"
        class="mb-4"
      >
        <div class="d-flex">
          <v-textarea
            @keydown.enter="handleCommentSubmit"
            auto-grow
            rows="3"
            v-model="comment"
            class="mb-2 mr-2"
            placeholder="Adicione um comentário..."
            outlined
            hide-details
          />
          <v-btn
            :disabled="!comment"
            color="primary"
            type="submit"
          >
            Comentar
          </v-btn>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import { conciliacaoClient } from '../../../libs'
import { sessionStorageClient } from '../../../libs'
import format from 'date-fns/format'

export default {
  props: {
    pagamentoId: String,
    pagamentoLoteId: String
  },
  data () {
    return {
      options: {
        itemsPerPage: 10,
        page: 1
      },
      comment: '',
    }
  },
  methods: {
    async handleCommentSubmit () {
      if (this.comment) {
        const data = {
          pagamentoId: this.pagamentoId,
          pagamentoLoteId: this.pagamentoLoteId,
          descricao: this.comment
        }

        try {
          await conciliacaoClient.pagamentoEvento.createPagamentoEvento(data)
          this.$asyncComputed.getComentariosPage.update()
          this.$refs.commentForm.reset()
          this.textFieldFocused = false
        } catch (error) {
          window.alert('Erro ao adicionar comentário.')
        }
      }
    },
    async handleDeleteComent (eventoId) {
      await conciliacaoClient.pagamentoEvento.deletePagamentoEvento(eventoId)
      this.$asyncComputed.getComentariosPage.update()
    }
  },
  computed: {
    sessionAuthor () {
      const sessionData = sessionStorageClient.getItem('userData')
      const sessionAuthor = sessionData?.Nome
      return sessionAuthor
    }
  },
  asyncComputed: {
    getComentariosPage: {
      get () {
        const params = {
          pageNumber: this.options.page - 1,
          pageSize: this.options.itemsPerPage,
          pagamentoId: this.pagamentoId,
          pagamentoLoteId: this.pagamentoLoteId,
          sorting: ["dataEvento"],
          tipoEvento: "comentario",
        }
        return conciliacaoClient.pagamentoEvento.getPagamentoEventosPage(params)
      }
    }
  },
  filters: {
    formatDataEvento(dataEvento) {
      const date = new Date(dataEvento)
      return format(date, 'dd/MM/yyyy')
    }
  }
}
</script>

<style scoped>
.comentario-form-container{
  width: 60%
}
</style>
